<div
  class="px-28 pb-12"
  fxLayoutAlign="end center"
  fxLayoutAlign.lt-sm="center"
>
  <mat-button-toggle-group
    #group="matButtonToggleGroup"
    (change)="handleViewChanged($event)"
  >
    <ng-container *ngFor="let view of allViews">
      <mat-button-toggle
        *ngIf="showViews.includes(view.value)"
        [title]="view.label"
        [value]="view.value"
        [checked]="viewPreference === view.value"
      >
        <mat-icon id="icon-color">{{ view.icon }}</mat-icon>
      </mat-button-toggle>
    </ng-container>
  </mat-button-toggle-group>
</div>
